

<template>
  <vs-row vs-w="12">
      <FiltersWithDateRange
        :selected="selected"
        :page="`average-treatment-by-age-${type}`"
        @updateFilters="selected = $event"
      />
      <!-- Chart -->
      <div class="w-full m-5" v-if="urlType === 'Supplier'">
        <label for>All Clinics</label>
        <vs-switch
          class="m-2"
          v-model="isAllClinics"
        />
      </div>
      <vs-col vs-w="12">
        <BarChart 
          :chartData="chartData"
          :chartOptions="chartOptions"
        />
      </vs-col>
    </vs-row>
</template>

<script>
import BarChart from '../charts/BarChart.vue';
import FiltersWithDateRange from '../common/FiltersWithDateRange.vue';

export default {
  components: {
    BarChart,
    FiltersWithDateRange,
  },
  props: {
    tabs: Array,
    type: {
      type: String,
    },
    selected: {
      type: Object,
    },
    chartDataProps: {
      type: Object,
    },
    isAllClinicsProps: {
      type: Boolean,
    },
    urlType: {
      type: String,
    },
  },
  data() {
    return {
      isAllClinics: false,
      chartData: {},
      chartOptions: {
        responsive: true,
        plugins: {
          legend: {
            display: false,
            position: 'bottom',
            labels: {
              boxWidth: 12,
            },
          },
          title: {
            display: true,
            text: '',
          },
        },
        scales: {
          y: {
            title: {
              display: true,
              text: 'AVERAGE UNIT PER TREATMENT',
            },
            
          },
          x: {
            title: {
              display: true,
              text: 'AGE BRACKET',
            },
            grid : {
                display : false,
            },
          },
        },   
      },
    };
  },
  watch: {
    chartDataProps: {
      handler(newVal){
        this.chartData = newVal;
      },
      immediate: true,
    },
    chartData: {
      handler(newVal) {
        this.$emit('updateChartData', newVal);
      },
      deep: true,
    },
    isAllClinicsProps: {
      handler(newVal){
        this.isAllClinics = newVal;
      },
      immediate: true,
    },
    isAllClinics: {
      handler(newVal){
        this.$emit('updateIsAllClinics', newVal);
      },
    },
  },
};
</script>

<style >


</style>